module.exports = {
  SINGLE: 'single',
  MARRIED: 'married',
  WIDOWED: 'widowed',
  CONCUBINE: 'concubine',
  CIVIL_UNION: 'civil-union',
  DIVORCED: 'divorced',
  PENDING_DIVORCE: 'pending-divorce',
};
